// extracted by mini-css-extract-plugin
export default {"button":"button_button__aMB50","loader":"button_loader__+mAzc"};